import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import * as utils from "../../../components/utils.js";
import Editor from '@monaco-editor/react';

const Macro_Editor = ({ node, files, macros, onChange, parent }) => {
    const [item, setItem] = useState(node);

    const _notifyChange = () => {
        if (onChange) {
            onChange(item);
        }
    }

    useEffect(() => {
        window.$("#ai_macro_selector").select2({  dropdownParent: window.$(`#${parent}`)});
        window.$("#ai_macro_selector").off("macro");
        window.$("#ai_macro_selector").on("change", (e) => {
            item.macro = e.target.value ? e.target.value : null;
            setItem(utils.clone(item));
            _notifyChange();
        });
    }, []);

    useEffect(() => {
        //nop
    }, [item]);

    return (
        <div>
            <p>This is a MACRO editor. You can choose an existing MACRO or write javascript code to be executed.</p>
            <div class="form-group">
                <label for="ai_editor_name">Name</label>
                <input type="text" className="form-control" id="ai_editor_name" aria-describedby="ai_editor_name_help" placeholder="Enter the name"
                    value={item.name} onChange={(e) => {
                        item.name = e.target.value;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                />
                <div class="form-text" >The name used for flows and macros for output data will be: <strong>{utils.code_name(item.name)}</strong></div>
            </div>
            <br></br>
            <div class="form-group">
                <label for="ai_macro_selector">Execute this macro</label>
                <select id="ai_macro_selector" value={item.macro} onChange={(e) => {
                    item.macro = e.target.value ? e.target.value : null;
                    setItem(utils.clone(item));
                    _notifyChange();
                }}>
                    {
                        [(<option value="">(local)</option>)]
                            .concat(
                                macros.map((f) => {
                                    return (<option value={f.Id}>{f.name}</option>);
                                }))}
                </select>
            </div>
            <hr></hr>
            {
                (item.macro ? (null) : (<Editor
                    height="50vh"
                    defaultLanguage="javascript"
                    theme='vs-dark'
                    defaultValue={item.code ?? ""}
                    onChange={(e) => {
                        item.code = e ? e : null;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                    />))
            }
        </div>);
}

export { Macro_Editor }